import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const RecargaPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Recargas</PageTitle>
      <View />
    </>
  );
};

export { RecargaPage };
